export default {
      id: "icon-dealer-search-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-dealer-search",
      toString: function () {
        return this.url;
      }
    }